export default __webpack_public_path__ + "static/media/logo.3cc6698c.jpeg";